import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(form.email, form.password);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grain relative flex min-h-screen items-center justify-center bg-brand-ink px-4">
      <div data-testid="admin-login-card" className="card-k w-full max-w-md p-8">
        <div className="flex justify-center"><img src="/sportive-logo.png" alt="SPORTIVE" className="h-12 drop-shadow-[0_0_18px_rgba(155,174,27,0.45)]" /></div>
        <h1 className="mt-6 text-center font-display text-3xl font-bold uppercase text-white">Admin Console</h1>
        <p className="mt-1 text-center font-mono text-[11px] tracking-[0.25em] text-slate-500">EVENT MANAGEMENT SYSTEM</p>
        {error && <p data-testid="admin-login-error" className="mt-5 rounded-lg border border-red-500/40 bg-red-500/10 px-4 py-2.5 text-sm text-red-400">{error}</p>}
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input data-testid="admin-email" type="email" required placeholder="Admin email" className="input-k" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          <input data-testid="admin-password" type="password" required placeholder="Password" className="input-k" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          <button data-testid="admin-login-submit" disabled={busy} className="btn-kinetic btn-primary-k w-full justify-center disabled:opacity-60">{busy ? "Signing in..." : "SIGN IN"}</button>
        </form>
        <div className="mt-5 flex items-center justify-between text-xs">
          <Link to="/forgot-password" data-testid="forgot-password-link" className="text-brand-cyan hover:underline">Forgot password?</Link>
          <Link to="/" className="text-slate-500 hover:text-white transition-colors">Back to site</Link>
        </div>
      </div>
    </div>
  );
}
